export default __webpack_public_path__ + "static/mg12-7b1366d11d683000c448eeec17c0be3d.jpg";